import { Cabinet } from '../../../../lib/modelBuilder/entities/Cabinet';
import { Shelf } from '../../../../lib/modelBuilder/entities/Shelf';
import { findColor } from '../../../../lib/modelBuilder/utils/colorHelper';
import { Furniture } from '../../../../lib/modelBuilder/entities/Furniture';

export function* addOrUpdateUpperShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { color } = payload;
  cabinetNext.addOrUpdateUpperShelf(undefined, undefined, findColor(color));
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* removeUpperShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  cabinetNext.removeUpperShelf();
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* addOrUpdateFurnitureUpperShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
  furnitureOrigin: Furniture,
  furnitureNext: Furniture,
) {
  const { color } = payload;
  furnitureNext.addOrUpdateUpperShelf(undefined, undefined, findColor(color));
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* removeFurnitureUpperShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
  furnitureOrigin: Furniture,
  furnitureNext: Furniture,
) {
  furnitureNext.upperShelf = undefined;
  return {
    ignore: false,
    postSuccess: null,
  };
}
